// @flow

import styled from 'styled-components';
import type { Theme } from '../../types';

const Table = styled<any, Theme>('table')`
  border-radius: 6px;
  border: 1px solid ${props => props.theme.table.borderColor};
  border-spacing: 0;
  width: 100%;

  tr:last-child td {
    border-bottom: 0;
  }
`;

export default Table;
